import { Checkbox, FormControlLabel } from '@mui/material';
import { ChangeEvent } from 'react';
import { MailSendoutDto } from '../../../../common/PricePrgClient';

type Props = {
    availableMailSendouts: MailSendoutDto[];
    selectedMailSendoutIds: string[];
    setSelectedMailSendoutIds(mailSendoutIds: string[]): void;
};

export const MailSendoutChooser = ({
    availableMailSendouts,
    selectedMailSendoutIds,
    setSelectedMailSendoutIds
}: Props) => {
    const handleMailSendoutIdsChanged = (mailSendoutId: string, event: ChangeEvent<HTMLInputElement>) => {
        const added = event.target.checked;

        setSelectedMailSendoutIds(
            added
                ? [...selectedMailSendoutIds, mailSendoutId]
                : selectedMailSendoutIds.filter(x => x !== mailSendoutId)
        );
    };

    return (
        <>
            {availableMailSendouts.map((mailSendout, idx) => (
                <FormControlLabel
                    key={idx}
                    control={
                        <Checkbox
                            checked={selectedMailSendoutIds.includes(mailSendout.mailSendoutId)}
                            onChange={e => handleMailSendoutIdsChanged(mailSendout.mailSendoutId, e)}
                        />
                    }
                    label={mailSendout.name}
                />
            ))}
        </>
    );
};
